import { CircularProgress, Stack, Typography } from "@mui/material";
import { AccountListItem } from "../../../types";
import { useEffect, useState } from "react";
import { AnalysisStatus } from "../../../types/companyTypes";
import { AccountPlanStatus } from "../../../types/enums";
import { ReuseTooltip } from "../ReuseTooltip";
import { LinerProgress } from "./LinerProgress";
import { AnalyseProgress } from "./AnalyseProgress";

export const ProgressBar = ({ data }: { data: AccountListItem }) => {
  const [isAnalyse, setIsAnalyse] = useState<boolean>(false);
  const {
    status,
    scraping_status: currentScrapingStatus,
    scraping_update_status: currentScrapingUpdateStatus,
    progress,
    account_plan_status,
  } = data;

  useEffect(() => {
    if (progress === 100) {
      setIsAnalyse(false);
    }
  }, [progress]);

  const isScraping = [AnalysisStatus.queued, AnalysisStatus.in_progress].some(
    (status) => status === currentScrapingStatus,
  );

  const isScrapingUpdate = [
    AnalysisStatus.queued,
    AnalysisStatus.in_progress,
  ].some((status) => status === currentScrapingUpdateStatus);

  const isAnalyzing = AnalysisStatus.in_progress === status;
  const isAnalyzeQueued = AnalysisStatus.queued === status;
  const isScrapingQueued = [
    currentScrapingStatus,
    currentScrapingUpdateStatus,
  ].some((status) => status === AnalysisStatus.queued);

  useEffect(() => {
    if (
      isScraping ||
      isScrapingUpdate ||
      isAnalyzeQueued ||
      isAnalyzing ||
      isScrapingQueued
    ) {
      setIsAnalyse(true);
    } else {
      setIsAnalyse(false);
    }
  }, [
    isScraping,
    isScrapingUpdate,
    isAnalyzing,
    isAnalyzeQueued,
    isScrapingQueued,
  ]);

  if (account_plan_status === AccountPlanStatus.in_progress) {
    return (
      <Stack
        direction="row"
        gap="8px"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress size={24} sx={{ color: "custom.subTitleModal" }} />
        <ReuseTooltip
          text={
            "Generation may take a few hours to complete due to the high volume of information to be analyzed." +
            " You'll be notified by email when the generation is complete."
          }
          maxWidth="184px"
        >
          <Typography
            variant="button"
            sx={{ fontWeight: 500, whiteSpace: "nowrap" }}
          >
            Generating Intelligence Plan
          </Typography>
        </ReuseTooltip>
      </Stack>
    );
  }

  return isAnalyse ? (
    <AnalyseProgress
      isAnalyzing={isAnalyzing}
      isScrapingQueued={isScrapingQueued}
      isAnalyzeQueued={isAnalyzeQueued}
      progress={progress}
      setIsAnalyse={setIsAnalyse}
    />
  ) : (
    <LinerProgress data={data} />
  );
};
